export default theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100vh',
  },
  grid: {
    height: '100%',
  },
  quote: {
    height: '100%',
    backgroundImage: 'url(/images/sign_up_1.jpg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundColor: theme.palette.common.neutral,
  },
  container: {
    backgroundColor: theme.palette.background.dark,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    display: 'grid',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    padding: theme.spacing(0, 4.5, 0, 4.5),
    [theme.breakpoints.up('lg')]: {
      alignItems: 'center',
      gridAutoRows: 'min-content',
      gap: theme.spacing(30),
      paddingTop: theme.spacing(10),
    },
  },
  logo: {
    width: 152,
    position: 'absolute',
    [theme.breakpoints.up('lg')]: {
      position: 'unset',
    },
  },
  form: {
    display: 'grid',
    gap: theme.spacing(3),
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: theme.spacing(3),
    backgroundColor: theme.palette.primary.serena,
  },
  title: {
    color: theme.palette.text.contrast,
  },
  text: {
    color: theme.palette.text.contrast,
    maxWidth: theme.spacing(42.75),
  },
  button: {
    width: 'max-content',
    padding: theme.spacing(1.25, 2),
    backgroundColor: theme.palette.primary.serena,
    color: theme.palette.common.white,
    borderRadius: '24px',
    '&:hover': {
      backgroundColor: theme.palette.primary.serena,
      opacity: '0.6',
    },
  },
  progress: {
    display: 'block',
    marginRight: theme.spacing(1),
  },
});
